import 'react-app-polyfill/ie11';
import 'element-scroll-polyfill';
import 'react-app-polyfill/stable';

import React from 'react';
import ReactDOM from 'react-dom';
import {GoogleMapsContextProvider, LocationAnalyticsSearchBoxWrapper} from '@ongov/location-react-components/src/components'

import { I18nextProvider } from 'react-i18next';

import i18n from './i18n';
import homeIcon from './home.svg';
import customLocations from 'data/lib/gen/homes-for-autocomplete';

const language = document.body.parentElement?.getAttribute(`lang`) ?? `en`;
i18n.changeLanguage(language.match(/^fr-*/i) ? `fr` : `en`);

ReactDOM.render(
  <React.StrictMode>
    <I18nextProvider i18n={i18n}>
      <GoogleMapsContextProvider apiKey={process.env.REACT_APP_GATSBY_GOOGLE_API_KEY} mapId={process.env.REACT_APP_GATSBY_GOOGLE_MAP_ID}>
        <LocationAnalyticsSearchBoxWrapper customLocations={customLocations} customLocationIcon={homeIcon} gaProductName={`long-term care locations`} />
      </GoogleMapsContextProvider>
    </I18nextProvider>
  </React.StrictMode>,
  document.getElementById('ltc-search-box')
);
